<template>
  <div class="roma-page-content fill-height grey lighten-4">
    <TaskCard :task="task" />

    <div class="task-detail">
      <v-row>
        <v-col md="6">
          <v-container>
            <v-row>
              <v-col cols="12">
                <p class="title-task">
                  Respuesta
                </p>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <quillEditor
                  class="lesson-detail__quill"
                  :content="task.taskDescription"
                  :options="editorOption"
                  :disabled="true"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <template v-for="(file, i) in task.taskFileList">
                  <v-chip
                    :key="i"
                    v-if="file.proprietary == 'STUDENT'"
                    class="ma-2"
                    link
                    target="_blank"
                    :href="`${link}${file.taskFileId}`"
                    color="orange"
                    text-color="white"
                  >
                    <v-avatar left>
                      <v-icon>mdi-download</v-icon>
                    </v-avatar>
                    {{ file.fileName }}
                  </v-chip>
                </template>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
        <v-col md="6">
          <v-form v-model="isValid">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <p class="title-task">Evaluación</p>
                </v-col>
              </v-row>

              <template v-if="!task.taskCheckedDate">
                <!-- <template> -->
                <v-row>
                  <v-col cols="12" class=" d-flex align-center">
                      <v-icon color="orange" class=" ma-1">mdi-progress-check</v-icon>
                      <h3 class=" d-inline mr-1">Pendiente por evaluar</h3>
                  </v-col>
                </v-row>
              </template>

              <template v-else>
                <v-row>
                  <v-col>
                    <v-icon color="green">mdi-check</v-icon>
                    Se ha realizado la evaluación de esta actividad
                  </v-col>
                </v-row>

                <v-row>
                  <v-col
                    v-if="
                      task.activityTO.evaluationFormat == 'NOTA' ||
                        task.activityTO.evaluationFormat == 'NOTA_LOGRO'
                    "
                  >
                    <p>Nota: {{ task.score }} </p>
                  </v-col>

                  <v-col
                    v-if="
                      task.activityTO.evaluationFormat == 'LOGRO' ||
                        task.activityTO.evaluationFormat == 'NOTA_LOGRO'
                    "
                  >
                    <p>Logro: {{ task.achievement }} %</p>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <h3>Retroalimentación:</h3>
                    <quillEditor
                      class="lesson-detail__quill"
                      :content="task.feedback"
                      :options="editorOption"
                      :disabled="true"
                    />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <template v-for="(file, i) in task.taskFileList">
                      <v-chip
                        :key="i"
                        v-if="file.proprietary == 'TEACHER'"
                        class="ma-2"
                        link
                        target="_blank"
                        :href="`${link}${file.taskFileId}`"
                        color="orange"
                        text-color="white"
                      >
                        <v-avatar left>
                          <v-icon>mdi-download</v-icon>
                        </v-avatar>
                        {{ file.fileName }}
                      </v-chip>
                    </template>
                  </v-col>
                </v-row>
              </template>
            </v-container>
          </v-form>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import TaskCard from "@/components/task/TaskCard.vue";
// import TipTap from "@/components/commons/RomaTipTap";

import { quillEditor } from "vue-quill-editor";
import { mapActions, mapGetters } from "vuex";

export default {
  components: { TaskCard, quillEditor },
  data() {
    return {
      editorOption: {
        readOnly: true,
        modules: {
          toolbar: false
        },
        placeholder: ''
      },
      filesTask: [],
      score: null,
      achievement: null,
      feedback: "",
      isFeedback: false,
      rules: {
        score: [
          v => !!v || "Este campo es requerido",
          v => v < 7 || "El campo debe ser menor o igual a 7"
        ],
        achievement: [
          v => !!v || "Este campo es requerido",
          v => v < 100 || "El campo debe ser menor o igual a 100"
        ]
      },
      isValid: true
    };
  },
  computed: {
    ...mapGetters({
      task: "getCurrentTask"
    }),
    link() {
      return `${process.env.VUE_APP_ROMA_PLANNER_API_URL}file/dowload/task/`;
    }
  },
  async mounted() {
    // this.updateItem
    //     ? await this.actionGetLesson(this.updateItem)
    //     : this.resetLessonUpdate();

    if (this.$route.params.id) {
      console.log("CONSULTANDO");
      await this.actionGetTask({ taskId: this.$route.params.id });
      this.updateMode(this.task);
    }

    // await this.actionGetInformationLesson(this.getInstitutionId);
    // this.$route.params.id ? this.updateMode(this.getLesson) : false;
  },
  methods: {
    ...mapActions({
      actionGetTask: "actionGetTask",
      actionSendTaskFeedback: "actionSendTaskFeedback",
      toastSuccess: "toastSuccess"
    }),
    setFeedback(feedback) {
      this.feedback = feedback;
    },
    updateMode(data) {
      if (data) {
        this.score = data.score;
        this.achievement = data.achievement;
        this.feedback = data.feedback;
        this.isFeedback = data.feedback ? true : false;
      }
    },

    createOrUpdate() {
      //only send
      this.sendTaskFeedback();
    },

    sendTaskFeedback() {
      const form = new FormData();

      form.append("taskId", this.task.taskId);
      form.append("feedback", this.feedback);
      form.append("score", this.score);

      this.achievement ? form.append("achievement", this.achievement) : "";

      this.filesTask.forEach((element, i) => {
        form.append("files", this.filesTask[i]);
      });

      console.log("### ENVIAR RETROALIMENTACION ###");
      for (const pair of form.entries()) {
        console.log(pair[0] + ", " + pair[1]);
      }

      this.actionSendTaskFeedback(form)
        .then(() => {
          this.toastSuccess({
            message: `Se ha evaluado la actividad`
          });
          this.goBack();
        })
        .catch(error => console.log(error));
    }
  }
};
</script>

<style lang="scss" scoped>
.task-detail {
  margin-top: 0.5rem;
  width: 100%;
  padding-bottom: 0%;
  background: #ffffff;
  border-radius: 5px;
  //   padding: 1rem;
  // box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
  //     0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);

  .title-task {
    color: #539dd4;
    font-size: 18px;
    text-transform: uppercase;
  }
}
.lesson-detail__quill {
  .ql-container.ql-snow {
    border: none !important;
  }
}
</style>
